import React, { useEffect, useMemo, useState } from "react";
import LogoWhite from "../../Assets/images/logo_white.svg";
import TalkMicIcon from "../../Assets/svgs/TalkMicIcon";
import TalkAssistantIcon from "../../Assets/svgs/TalkAssistantIcon";
import { vapi } from "./Talk";
import { CallIcon } from "../../Assets/svgs/CallIcon";
import SmallLogoIcon from "../../Assets/svgs/SmallLogoIcon";
import ChatBG from "../../Assets/images/chat-bg.png";

const TalkBox = ({ isSpeaking, onEndCall, callData }) => {
  const [caption, setCaption] = useState({
    visible: false,
    isAssistant: false,
    text: "",
    image: "",
  });
  const [time, setTime] = useState(0);

  let debounceTimeout;

  const showCaption = (text, isAssistant, callback) => {
    clearTimeout(debounceTimeout);

    setCaption({
      visible: true,
      isAssistant: isAssistant,
      text: text,
      image: isAssistant
        ? callData?.assistantDetails?.avatar
        : callData?.contactDetails?.avatar,
    });

    debounceTimeout = setTimeout(() => {
      setCaption({ visible: false, text: "", image: "", isAssistant: false });
      if (typeof callback === "function") {
        callback();
      }
    }, 5000); // 5 seconds for captions to remain visible
  };

  const callTime = useMemo(() => {
    const minutes = Math.floor(time / 60);
    const secs = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  }, [time]);

  useEffect(() => {
    const listener = (message) => {
      if (message?.type === "transcript") {
        showCaption(message?.transcript, message?.role === "assistant");
      }
    };

    vapi.on("message", listener);

    return () => {
      vapi.removeListener("message", listener);
    };
  }, [callData]);

  useEffect(() => {
    return () => {
      clearTimeout(debounceTimeout);
    };
  }, []);

  useEffect(() => {
    let timer;

    timer = setInterval(() => {
      setTime((prevTime) => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="layoutContainer layoutContainer--full">
      <div className="layoutGrid">
        <div
          className="page page--loginOtp page--chatBg"
          style={{
            background: `url(${
              typeof callData?.assistantDetails?.webScreen === "string" &&
              callData?.assistantDetails?.webScreen?.length
                ? callData?.assistantDetails?.webScreen
                : ChatBG
            }) no-repeat`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        >
          <div className="page__head">
            <div className="page__head__logo">
              <img
                src={callData?.contactDetails?.customer?.logo ?? LogoWhite}
                alt="Logo | Vox App"
              />
            </div>
          </div>
          <div className="page__body">
            <div className="chatwrap">
              <div className="chatwrap__head">
                {/* <h1 className="title title--h1">
                  The Smartest AI Assistant,
                  <br /> Ready to Chat!
                </h1>
                <p className="para">
                  Simplify tasks, automate routines, and enjoy personalized
                  interactions—all in one chat.
                </p> */}
              </div>
              <div className="chatwrap__body">
                <div className={`chatIcon ${isSpeaking ? "speaking" : ""}`}>
                  <TalkMicIcon />
                </div>
                {/* {caption?.visible ? (
                  <p className="para">
                    <span className="icon">
                      {caption?.isAssistant ? (
                        caption?.image ? (
                          <img src={caption?.image} alt="" />
                        ) : (
                          <TalkAssistantIcon />
                        )
                      ) : (
                        <img src={caption?.image} alt="" />
                      )}
                    </span>
                    “{caption?.text}”
                  </p>
                ) : (
                  <p className="para" />
                  )} */}
                <p className="para" />
                <p className="para mb_0">
                  <span className="">
                    <CallIcon />
                  </span>
                  {callTime}
                </p>

                <div className="btn__group">
                  <button className="btn btn__danger" onClick={onEndCall}>
                    End Chat
                  </button>
                </div>
              </div>
              <div className="chatwrap__footer">
                <p className="para">
                  <SmallLogoIcon />
                  <a
                    style={{ color: "#fff" }}
                    href="http://www.voxapp.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Powered By VoxApp
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalkBox;
